import Mention from "@tiptap/extension-mention"
import { Attributes } from "@tiptap/core"
import { NodeSpec } from "prosemirror-model"
import { mergeAttributes } from "@tiptap/vue-2"

export interface Mentionable {
  id: number
  name: string
  key: string
  klass: "member-mention" | "group-mention"
}

export const SuusMention = Mention.extend({
  // Add attributes to the virtual mention node and
  addAttributes(): Attributes | {} {
    return {
      key: {
        renderHTML: (attributes) => ({ "data-key": attributes.key }),
      },
      type: {
        renderHTML: (attributes) => {
          return {
            class:
              attributes.type === "GroupMember"
                ? "mention member-mention"
                : "mention group-mention",
          }
        },
      },
      label: {
        renderHTML: (attributes) => ({ "data-label": attributes.label }),
      },
    }
  },

  // The set of conjunctive rules to parse a Mention-Node from HTML
  // @see https://tiptap.dev/guide/custom-extensions#parse-html
  parseHTML(): NodeSpec["parseDOM"] {
    return [
      {
        // match by css selector
        tag: "a.mention",

        // Link-extension watches also for a-Tags. Default is 50.
        priority: 100,

        // match by tag attributes
        getAttrs: (node) => {
          if (typeof node == "string") {
            // a style rule
            return false
          } else {
            // a Tag rule always receives a HTMLElement
            const htmlElement = node as HTMLElement

            try {
              if (htmlElement.classList.contains("mention")) {
                return {
                  key: htmlElement.getAttribute("data-key"),
                  type: htmlElement.getAttribute("data-key").split("#")[0],
                  label: htmlElement.innerHTML,
                }
              }
            } catch (e) {
              console.error(e)
              return false
            }
            return false
          }
        },
      },
    ]
  },

  // Render the Mention-Node to a HTML element
  // @see https://tiptap.dev/guide/custom-extensions#render-html
  renderHTML({ node, HTMLAttributes: htmlAttributes }) {
    return [
      "a", // name of the HTML tag to be used
      mergeAttributes(htmlAttributes, {
        style: "pointer-events: none",
      }), // attributes of the tag (optional, omit element otherwise)
      node.attrs.label, // content (or children)
    ]
  },
})
